import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/termo/empresa.png'
import _imports_1 from '../assets/termo/voltyplus-logo.svg'
import _imports_2 from '../assets/termo/voltynho-logo.png'
import _imports_3 from '../assets/termo/hydro.png'
import _imports_4 from '../assets/termo/volty_market_quadrado.png'


const _withScopeId = n => (_pushScopeId("data-v-62b6f3e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","height":"100vh","width":"100vw"} }
const _hoisted_2 = { style: {"margin":"auto","font-size":"20px","width":"500px","padding":"20px","text-align":"center","line-height":"1.5em"} }
const _hoisted_3 = { class: "produto" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "produto-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", null, "Termos de uso")
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "produto" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "produto-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Voltynho",
    title: "Voltynho"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", null, "Termos de uso")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "produto" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "produto-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", null, "Termos de uso")
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "produto" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "produto-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", null, "Termos de uso")
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "produto" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "produto-logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", null, "Termos de uso")
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":".7em","padding-left":"40px","padding-right":"40px"} }, "Para visualizar os termos, basta clicar em Termos de Uso no respectivo produto.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", {
          style: {"cursor":"pointer"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/termo/empresa'))),
          class: "produto-label"
        }, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", {
          style: {"cursor":"pointer"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/termo/volty'))),
          class: "produto-label"
        }, _hoisted_10)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", {
          style: {"cursor":"pointer"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/termo/voltynho'))),
          class: "produto-label"
        }, _hoisted_14)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", {
          style: {"cursor":"pointer"},
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/termo/hydro'))),
          class: "produto-label"
        }, _hoisted_18)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", {
          style: {"cursor":"pointer"},
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/termo/volty_market'))),
          class: "produto-label"
        }, _hoisted_22)
      ]),
      _hoisted_23
    ])
  ]))
}